export default __webpack_public_path__ + "static/media/left.d73be2b4.svg";